import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { campaignAction } from "../../../store/campaign-store";

const GalleryList = (props) => {
  // const [is_loader, setIsLoader] = useState(false);
  const [gallery, setGallery] = useState([]);
  const is_loaded_img = useSelector((state) => state.campaign.is_loaded_img);

  const { sendRequest: fetchGallery } = useHttp();

  const { toggleRightshow } = props;
  const galleryData = useSelector((state) => state.campaign.gallery);
  const dispatch = useDispatch();

  const single_layer = useSelector((state) => state.campaign.single_layer);

  // console.log(single_layer);
  const editSlideData = useSelector((state) => state.campaign.editSlideData);

  useEffect(() => {
    const responseData = (response) => {
      if (response.length > 0) {
        dispatch(campaignAction.setGallery({ gallery: response }));
        dispatch(campaignAction.setImageLoadedS3({ is_loaded_img: true }));
      }
    };
    if (!is_loaded_img) {
      fetchGallery({ url: endPoints.myGallery, method: "GET" }, responseData);
    }
  }, [dispatch, fetchGallery, galleryData, is_loaded_img]);

  useEffect(() => {
    if (is_loaded_img) {
      setGallery(galleryData);
    }
  }, [galleryData, is_loaded_img]);

  //   console.log(gallery.length);

  const updateNewData = async (e, url, type = "new") => {
    e.preventDefault();

    if (single_layer.name.indexOf("bg_image") === 0 && type === "new") {
      dispatch(campaignAction.setImageEditor({ content: url }));
    } else {
      let new_layer_data = { ...single_layer };
      console.log(new_layer_data);

      new_layer_data.src = url;

      console.log(new_layer_data);

      await dispatch(
        campaignAction.setSingleLayerData({ data: new_layer_data })
      );

      await dispatch(
        campaignAction.setSingleSlideData({ layer_name: single_layer.name })
      );

      dispatch(campaignAction.appendVideoData());

      var newData = { ...editSlideData };

      if (single_layer.name === "logo") {
        newData.logo = url;
      } else {
        newData[single_layer.name] = url;
      }
      dispatch(campaignAction.setSlideData({ data: newData }));

      dispatch(campaignAction.setImageLoadedS3({ is_loaded_img: false }));
    }
    toggleRightshow();
  };

  return (
    <div className="row">
      <div className="container">
        <div className="media_gallery">
          {gallery.length > 0 && (
            <ul>
              <li>
                <img
                  src={single_layer.default_src}
                  className="img_full"
                  alt="img"
                />
                <a
                  href="#0"
                  onClick={(e) =>
                    updateNewData(e, single_layer.default_src, "default")
                  }
                  className="hvr"
                >
                  <span className="btn">Use Default</span>
                </a>
              </li>
              {gallery.length > 0 &&
                gallery.map((single) => {
                  return (
                    <div key={single.Key}>
                      {single.key !== "" && (
                        <li key={single.Key}>
                          <img
                            src={single.Key}
                            className="img_full"
                            alt="img"
                          />
                          <a
                            href="#0"
                            onClick={(e) => updateNewData(e, single.Key, "new")}
                            className="hvr"
                          >
                            <span className="btn">Select</span>
                          </a>
                        </li>
                      )}
                    </div>
                  );
                })}
            </ul>
          )}

          {gallery.length === 0 && (
            <p className="text-center">
              <b>
                You have not uploaded any image yet.
                <br />
                Please upload your image{" "}
              </b>
            </p>
          )}
          <div className="clearfix"></div>
        </div>
      </div>
    </div>
  );
};

export default GalleryList;
